import api from "./api";

/**
 * GIF keyboard (GIPHY, proxied by the backend so the API key stays server-side).
 * Results are already filtered to the workplace content rating.
 *
 * A GIF looks like:
 *   { id, title, url, width, height, preview_url, preview_width, preview_height }
 * Only `id` is sent with a recognition; the server re-resolves the rest.
 */
let statusPromise = null;

const gifsService = {
  /** -> { enabled }; fetched once per page load. */
  getStatus: () => {
    if (!statusPromise) {
      statusPromise = api
        .get("/api/v1/gifs/status")
        .then((r) => r.data)
        .catch(() => {
          statusPromise = null;
          return { enabled: false };
        });
    }
    return statusPromise;
  },

  /** -> { results, next_offset } */
  trending: async ({ offset = 0, limit = 24 } = {}) => {
    const response = await api.get("/api/v1/gifs/trending", { params: { offset, limit } });
    return response.data;
  },

  /** -> { results, next_offset } */
  search: async (q, { offset = 0, limit = 24 } = {}) => {
    const response = await api.get("/api/v1/gifs/search", { params: { q, offset, limit } });
    return response.data;
  },
};

export default gifsService;
